import axios from 'axios'
import { reactive, watch } from 'vue'
import { get, cloneDeep, isEqual, mapValues, has } from 'lodash'

export default function (data = {}) {
    let defaults = cloneDeep(data)
    let transform = (data) => data
    let recentlySuccessfulTimeoutId = null

    let form = reactive({
        ...data,
        isDirty: false,
        hasErrors: false,
        errors: {},
        processing: false,
        wasSuccessful: false,
        recentlySuccessful: false,
        data() {
            return Object.keys(data).reduce((carry, key) => {
                carry[key] = this[key]
                return carry
            }, {})
        },
        transform(callback) {
            transform = callback

            return this
        },

        reset(...fields) {
            let clonedDefaults = cloneDeep(defaults)

            if (fields.length === 0) {
                Object.assign(this, clonedDefaults)
            } else {
                Object.assign(
                    this,
                    Object.keys(clonedDefaults)
                        .filter((key) => fields.includes(key))
                        .reduce((carry, key) => {
                            carry[key] = clonedDefaults[key]
                            return carry
                        }, {})
                )
            }
            return this
        },

        clearErrors(...fields) {
            this.errors = Object.keys(this.errors).reduce(
                (carry, field) => ({
                    ...carry,
                    ...(fields.length > 0 && !fields.includes(field)
                        ? { [field]: this.errors[field] }
                        : {}),
                }),
                {}
            )

            this.hasErrors = Object.keys(this.errors).length > 0

            return this
        },

        dirty(key) {
            if (!this.isDirty) return false
            return !isEqual(this[key], defaults[key])
        },

        submit(method, url, options = {}) {
            const data = transform(this.data())

            this.processing = true
            this.wasSuccessful = false
            this.hasErrors = false
            this.recentlySuccessful = false
            clearTimeout(recentlySuccessfulTimeoutId)

            const successHandler = (res) => {
                this.processing = false
                this.errors = {}
                this.wasSuccessful = true
                this.recentlySuccessful = true
                recentlySuccessfulTimeoutId = setTimeout(
                    () => (this.recentlySuccessful = false),
                    2000
                )

                if (options.onSuccess) {
                    options.onSuccess(res.data)
                }

                defaults = cloneDeep(this.data())

                if(has(res, 'data.redirect_to')) {
                    window.location.assign(get(res, 'data.redirect_to'))
                }
            }

            const errorHandler = (err) => {
                if (err?.response?.status == 419) {
                    axios.get('/csrf').then(() => {
                        axios({ method, url, data })
                            .then(successHandler)
                            .catch(errorHandler)
                    })
                }

                if (err?.response?.status == 401) {
                    window.location.reload()
                }

                this.processing = false

                if (err?.response?.status == 422) {
                    this.hasErrors = true

                    let errors = mapValues(
                        err.response.data.errors,
                        (value) => {
                            return value[0]
                        }
                    )

                    // errors = object(errors)

                    this.errors = errors

                    if (options.onValidationError) {
                        options.onValidationError(errors)
                    }
                }

                if (options.onError) {
                    return options.onError(err?.response?.status)
                }
            }

            document.activeElement.blur()

            axios({ method, url, data })
                .then(successHandler)
                .catch(errorHandler)
        },
        get(url, options) {
            this.submit('get', url, options)
        },
        post(url, options) {
            this.submit('post', url, options)
        },
        put(url, options) {
            this.submit('put', url, options)
        },
        patch(url, options) {
            this.submit('patch', url, options)
        },
        delete(url, options) {
            this.submit('delete', url, options)
        },
    })

    watch(
        form,
        (newValue) => {
            form.isDirty = !isEqual(form.data(), defaults)
        },
        { immediate: true, deep: true }
    )

    return form
}
